// epidemicService.js
import { getFunctions, httpsCallable } from 'firebase/functions';

export const getAirQuality = async (params = {}) => {
  try {
    console.log('Appel getAirQuality...');
    const functions = getFunctions(undefined, 'europe-west1');
    const getAirQualityFn = httpsCallable(functions, 'getAirQuality');

    const result = await getAirQualityFn(params);

    return {
      regions: result.data.regions,
      source: result.data.source,
      lastUpdate: result.data.lastUpdate,
      isRealData: result.data.isRealData,
    };
  } catch (error) {
    console.error('Erreur getAirQuality:', error.code, error.message, error);

    // Fallback statique en cas d'erreur réseau
    const fallbackRegions = {
      'ile-de-france':              { aqi: 3, label: 'Modéré',       color: '#F59E0B', pm25: 15, pm10: 25, no2: 50, o3: 90 },
      'auvergne-rhone-alpes':       { aqi: 2, label: 'Correct',      color: '#84CC16', pm25: 10, pm10: 18, no2: 30, o3: 75 },
      'bourgogne-franche-comte':    { aqi: 2, label: 'Correct',      color: '#84CC16', pm25:  9, pm10: 16, no2: 25, o3: 70 },
      'bretagne':                   { aqi: 1, label: 'Bon',          color: '#10B981', pm25:  6, pm10: 12, no2: 15, o3: 60 },
      'centre-val-de-loire':        { aqi: 2, label: 'Correct',      color: '#84CC16', pm25: 10, pm10: 17, no2: 28, o3: 72 },
      'grand-est':                  { aqi: 3, label: 'Modéré',       color: '#F59E0B', pm25: 14, pm10: 23, no2: 45, o3: 85 },
      'hauts-de-france':            { aqi: 3, label: 'Modéré',       color: '#F59E0B', pm25: 16, pm10: 26, no2: 52, o3: 88 },
      'normandie':                  { aqi: 2, label: 'Correct',      color: '#84CC16', pm25:  8, pm10: 15, no2: 22, o3: 65 },
      'nouvelle-aquitaine':         { aqi: 1, label: 'Bon',          color: '#10B981', pm25:  7, pm10: 13, no2: 18, o3: 62 },
      'occitanie':                  { aqi: 2, label: 'Correct',      color: '#84CC16', pm25: 11, pm10: 19, no2: 32, o3: 78 },
      'pays-de-la-loire':           { aqi: 2, label: 'Correct',      color: '#84CC16', pm25:  9, pm10: 16, no2: 24, o3: 68 },
      'provence-alpes-cote-d-azur': { aqi: 2, label: 'Correct',      color: '#84CC16', pm25: 12, pm10: 20, no2: 38, o3: 82 },
      'corse':                      { aqi: 1, label: 'Bon',          color: '#10B981', pm25:  5, pm10: 10, no2: 12, o3: 55 },
    };

    return {
      regions: fallbackRegions,
      source: 'Données de démonstration',
      lastUpdate: new Date().toISOString(),
      isRealData: false,
    };
  }
};
